module.exports = __webpack_public_path__ + "img/1.980ffa74.png";